import useSWR from 'swr';

import {
    getOrgDailyConsumptionByService,
    getTenantDailyConsumptionByService,
} from '../../../../services/licensing/ConsumptionDashboardService';

export const useConsumableOverviewData = (
    organizationId: string,
    consumableCode: string,
    tenantId: string | undefined,
    bundleStartDate: number | undefined,
    bundleEndDate: number | undefined,
) => {
    const key = bundleStartDate != null && bundleEndDate != null && bundleStartDate <= bundleEndDate
        ? [ 'consumables-v2-overview', organizationId, tenantId ?? null, consumableCode, bundleStartDate, bundleEndDate ] as const
        : null;
    const shouldFetch = key != null;

    const {
        data, error, isLoading,
    } = useSWR(
        key,
        ([ , , tenant, code, startDate, endDate ]: readonly [string, string, string | null, string, number, number]) =>
            tenant != null
                ? getTenantDailyConsumptionByService(code, tenant, startDate, endDate)
                : getOrgDailyConsumptionByService(code, startDate, endDate),
    );

    return {
        distributionData: data?.distribution ?? [],
        isLoading: shouldFetch && !error && (isLoading || !data),
        error: shouldFetch ? error : undefined,
    };
};
